<template>
<div class="chapter">
<div class="inner_page">
<p class="author"><a id="page_iii"></a>Marc Lee Raphael</p>
<h1 class="h1">The Synagogue in America</h1>
<p class="subtitle"><em>A Short History</em></p>
<p class="pub"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?30186a5b